var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"loaderAnim",staticClass:"loading"},[_c('div',{staticClass:"loader"})]),_c('div',{staticClass:"wrapper"},[_vm._t("above"),_c('canvas',{ref:"canvas",attrs:{"id":"canvas"}}),_vm._t("below")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }